import React, { useEffect, useMemo, useCallback, useState } from "react";
import { FormControl, InputLabel, OutlinedInput, Select, MenuItem, Checkbox, ListItemText, Grid } from "@mui/material";

const MENU_PROPS = {
  PaperProps: {
    style: {
      maxHeight: 48 * 4.5 + 8, // ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP
      width: 250,
    },
  },
};

const RequiredFieldForm = ({ data, setRequiredState }) => {
  const { required_fields, missing_value_action } = data;

  // Memoize required fields array
  // const requiredFields = required_fields;

  const [dummyRequiredState, setDummyRequiredState] = useState({})

  // Memoized handler for select changes
  const handleChange = useCallback((event) => {
    const value = event.target.value;
    const processedValue = typeof value === 'string' ? value.split(',') : value;
    let dum = JSON.parse(JSON.stringify(dummyRequiredState))
    dum.missing_value_action.fail = processedValue
    setDummyRequiredState(dum);
  }, [setDummyRequiredState, dummyRequiredState]);

  useEffect(() => {
    setDummyRequiredState(data)
  }, [data])

  // Sync state with parent when data changes
  useEffect(() => {
    setRequiredState(dummyRequiredState);
  }, [dummyRequiredState]);

  return (
    <Grid item xs={2} sm={2}>
      <FormControl fullWidth>
        <InputLabel>Required Field</InputLabel>
        <Select
          label="Required Field"
          multiple
          value={dummyRequiredState?.missing_value_action?.fail ?? []}
          onChange={handleChange}
          sx={{ height: '45px', '& .MuiSelect-select': { height: '45px !important' } }}
          input={<OutlinedInput label="Required Field" />}
          renderValue={(selected) => selected.join(', ')}
          MenuProps={MENU_PROPS}
        >
          {dummyRequiredState?.required_fields?.map((name) => (
            <MenuItem key={name} value={name} sx={{ mb: 1 }}>
              <Checkbox checked={dummyRequiredState?.missing_value_action?.fail.includes(name)} />
              <ListItemText secondary={name} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>
  );
};

export default RequiredFieldForm;
